// extracted by mini-css-extract-plugin
export default {"developmentsRoot":"DevsChrome_developmentsRoot__zqdsg"};